import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, MessageType, UpdateStatusType } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { DataAreaAndTreeComponent } from '../../data-area-and-tree/data-area-and-tree.component';
import { NameDescriptionComponent } from '../../name-description/name-description.component';
import { ProjectViewModel } from '../../../models/project';
import { DrObject } from '../../../models/dr-object';

@Component({
    standalone: false,
    selector: 'res-import-project-modal',
    templateUrl: './import-project-modal.component.html'
})
export class ImportProjectModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(NameDescriptionComponent, { static: true }) nameDescriptionComponent: NameDescriptionComponent;
    @ViewChild(DataAreaAndTreeComponent, { static: true }) dataAreaAndTreeComponent: DataAreaAndTreeComponent;
    validateNameRequest = {
        endpoint: Endpoint.viewManager_validateName,
        request: (name) => {
            return {
                name: name,
                organizationName: this.commonService.currentUser.customerName,
                objectType: this.nameDescriptionComponent.drObject.objectType
            };
        }
    };

    modalTitle = 'Import Project';
    modalAutomationId = 'import-project';
    verifyRequiredValidator = true;
    primaryButtonLabel = 'Import Project';
    secondaryButtonLabel = 'Cancel';
    selectedPath: string;
    modalHelpIndex = HelpIndex.import_case_project_dlg;
    isBusy = false;
    isBusyMessage = '';

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService,
        private router: Router) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.nameDescriptionComponent.drObject = new ProjectViewModel();
    }

    isPrimaryButtonEnabled(): boolean {
        let enabled = false;
        if (!this.isBusy) {
            if (!DrObject.isEmpty(this.nameDescriptionComponent.name)) {
                if (this.nameDescriptionComponent.isNameDirty() && (this.nameDescriptionComponent.formValid) && this.dataAreaAndTreeComponent.selectedPath) {
                    enabled = true;
                }

                if ((enabled === false) && (this.nameDescriptionComponent.isDescriptionDirty()) && (this.nameDescriptionComponent.formValid) && this.dataAreaAndTreeComponent.selectedPath) {
                    enabled = true;
                }

                if (!this.nameDescriptionComponent.isDescriptionDirty() && !this.nameDescriptionComponent.isNameDirty() && this.dataAreaAndTreeComponent.selectedPath) {
                    enabled = true;
                }
            }
        }
        return enabled;
    }

    onDataAreaAndTreeChange(): void {
        return;
    }

    importProject(): void {
        this.nameDescriptionComponent.validate().then(valid => {
            if (valid) {
                this.isBusy = true;
                this.isBusyMessage = 'Importing Project ...';
                let selectedPath = this.dataAreaAndTreeComponent.selectedPath.handle;
                if (selectedPath.includes(this.dataAreaAndTreeComponent.selectedDataArea.path)) {
                    selectedPath = selectedPath.replace(this.dataAreaAndTreeComponent.selectedDataArea.path, '');
                }
                const request = {
                    projectName: this.nameDescriptionComponent.name,
                    projectDescription: this.nameDescriptionComponent.description,
                    userProjectType: 'dr_eca',
                    dataAreaHandle: this.dataAreaAndTreeComponent.selectedDataArea.handle,
                    projectFileName: selectedPath,
                    attributes: [{ name: 'userprojecttype', value: 'dr_eca' }],
                    taskDescription: `Importing project ${this.nameDescriptionComponent.name}`,
                };
                this.restService.post(Endpoint.orgManager_importProject, request, true,
                    [MessageType.project, UpdateStatusType.IMPORT_PROJECT]).then(responseImportCase => {
                        this.isBusy = false;
                        this.closeModal(true, responseImportCase.project);
                    }, error => {
                        this.isBusy = false;
                    });
            }
        });
    }
}
